let authApp = null;

pageUnload('sessions_new', 'sessions_create', async () => {
  if (authApp) {
    authApp.unmount();
    authApp = null;
  }
});

pageLoad('sessions_new', 'sessions_create', async () => {
  const { createApp, h } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: Component } = await import('@/vue/modals/auth');

  const $node = $('.auth_wrapper .app');

  authApp = createApp({
    setup: () => () => h(Component, {
      graphqlUrl: $node.data('graphql_url'),
      confirmationUrl: $node.data('confirmation_url'),
      confirmationType: $node.data('confirmation_type'),
      resendCodeInterval: $node.data('resend_code_interval'),
      nextUrl: $node.data('next_url'),
      isSignInTab: true,
      privacyUrl: $node.data('privacy_url'),
      privacyConsentUrl: $node.data('privacy_consent_url'),
      signUpMethod: 'sign_up_form'
    })
  });
  authApp.mount($node[0]);
});
